// TODO: Remove this file when the /brands API endpoint is ready.
// Simulates server-side filter, sort, and paging against static mock data.
import { Injectable, inject } from '@angular/core';
import {
    ApiCollectionMetaData,
    ApiCollectionResponse,
    ApiSortDirection,
    SearchState,
} from '@cia-front-end-apps/shared/api-interaction';
import { NEVER, Observable, defer, of, throwError } from 'rxjs';
import { Brand } from '../models/brand';
import { MOCK_BRANDS, brandsForScenario } from './brand.mock-data';
import { BrandDemoScenarioService } from './brand-demo-scenario.service';

@Injectable()
export class BrandResourceDev {
    private readonly demoScenarioService = inject(BrandDemoScenarioService);

    /**
     * defer() reads the current scenario at subscription time so that invalidating
     * the query cache and refetching picks up the latest scenario automatically.
     */
    getAll(searchState: SearchState): Observable<ApiCollectionResponse<Brand>> {
        return defer(() => {
            const scenario = this.demoScenarioService.scenario();

            if (scenario === 'error') {
                return throwError(() => new Error('Mock error scenario'));
            }
            if (scenario === 'loading') {
                return NEVER;
            }

            const allItems = brandsForScenario(scenario);
            const filtered = this.applyFilter(allItems, searchState.search);
            const sorted = this.applySort(filtered, searchState.sortBy, searchState.sortDirection);
            const { page, total } = this.applyPaging(sorted, searchState.pageIndex, searchState.pageSize);

            return of(new ApiCollectionResponse<Brand>({
                items: page,
                meta: new ApiCollectionMetaData({ itemCount: total }),
            }));
        });
    }

    private applyFilter(items: Brand[], search?: string): Brand[] {
        if (!search) { return items; }
        const term = search.toLowerCase();
        return items.filter(b => b.brandName.toLowerCase().includes(term));
    }

    private applySort(items: Brand[], sortBy?: string, direction?: ApiSortDirection): Brand[] {
        const dir = direction === 'asc' ? 1 : -1; // default desc (newest first)
        return [...items].sort((a, b) => {
            if (sortBy === 'upcCount') {
                return dir * (a.upcCount - b.upcCount);
            }
            // default: sort by createdDate
            return dir * (new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime());
        });
    }

    private applyPaging(
        items: Brand[],
        pageIndex = 0,
        pageSize = 25,
    ): { page: Brand[]; total: number } {
        const total = items.length;
        const start = pageIndex * pageSize;
        return { page: items.slice(start, start + pageSize), total };
    }
}

export const MOCK_BRAND_TOTAL = MOCK_BRANDS.length;
